import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DuplicateQuestionMutationVariables = Types.Exact<{
  poolId: Types.Scalars['ID'];
  questionGroupId: Types.Scalars['ID'];
  targetPoolId: Types.Scalars['ID'];
}>;


export type DuplicateQuestionMutation = { __typename?: 'Mutation', duplicateQuestionGroup?: { __typename?: 'DuplicateQuestionGroupPayload', successful: boolean } | null };

export const DuplicateQuestionDocument = gql`
    mutation DuplicateQuestion($poolId: ID!, $questionGroupId: ID!, $targetPoolId: ID!) {
  duplicateQuestionGroup(
    poolId: $poolId
    questionGroupId: $questionGroupId
    targetPoolId: $targetPoolId
  ) {
    successful
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DuplicateQuestionGQL extends Apollo.Mutation<DuplicateQuestionMutation, DuplicateQuestionMutationVariables> {
    document = DuplicateQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }